import React from 'react';
import PropTypes from 'prop-types';
import { CampaignOData } from '@bingads-webui-react/campaign-odata';
import { notificationApi } from '@bingads-webui-campaign/notification-center';
import { shellTips } from '@bingads-webui-campaign-react/shell-ui-common';

// campaign by id api don't return delivery status information
export const WithCampaignRepository = ({
  campaignLoadFallback, WrappedComponent, i18n,
}) => (
  <CampaignOData
    call={({ currentAccount, currentCampaign }) => currentAccount.Campaigns.get({
        // finally this would become $expand=Budget&$select=Id,Name,Status,CampaignType,BiddingScheme,ExperimentId,CampaignSubType
        top: 1,
        filter: { where: `Id eq ${currentCampaign.navigation.key}` },
        select: [
          'Id',
          'Name',
          'Status',
          'CampaignType',
          'DeliveryStatus',
          'DeliveryStatusDetails',
          'Budget',
          'BiddingScheme',
          'ExperimentId',
          'CampaignSubType',
        ],
      })
    }
    escapeHatch={({ currentCampaign }) => (currentCampaign ? undefined : null)}
    fallback={campaignLoadFallback}
    onError={() => {
      notificationApi.showWarning(i18n.getString(shellTips.shellDataError));
      return campaignLoadFallback;
    }}
  >
    { campaignFromOData =>
      (<WrappedComponent campaignFromOData={campaignFromOData && campaignFromOData.value && campaignFromOData.value.length > 0 ? campaignFromOData.value[0] : null} />) }
  </CampaignOData>
);

WithCampaignRepository.propTypes = {
  campaignLoadFallback: PropTypes.element.isRequired,
  WrappedComponent: PropTypes.func.isRequired,
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
};
